module.exports = __webpack_public_path__ + "assets/img/honor5.9b715746.png";